module.exports = __webpack_public_path__ + "static/media/icon_navigation_arrow_back.13921808.svg";